import * as React from "react";

import "./street-addresses-table.scss";

import {cx}               from "emotion";
import {isApiTrue}        from "@Common/logic/is-api-true";
import {Checkbox}         from "@Common/ui-components/heavy/common/design2/checkbox/checkbox";
import {InformationBadge} from "@Common/ui-components/heavy/common/design2/information-badge/information-badge";

export const StreetAddressesTable = ({addresses, setAddressSelected, darkRow}) => (
    <div className={cx("street-addresses-table-1ri", {darkBackground: darkRow})}>
        {!addresses ? (
            <div className="loading">
                Loading addresses...
            </div>
        ) : (
            <table>
                <tbody>
                    {addresses.map((address, i) => (
                        <tr key={i} className={cx("address-row", {disabled: address.do_not_mail || address.excluded_target})}>
                            <td className="checkbox">
                                {Checkbox({
                                    ...address.do_not_mail || address.excluded_target ? {
                                        disabled: true,
                                        checked: false,
                                        xdQaName: address.address+" "+address.zip_code,
                                    } : {
                                        checked: isApiTrue(address.display_address),
                                        onClick: () => setAddressSelected(address),
                                        xdQaName: address.address+" "+address.zip_code,
                                    }
                                })}
                            </td>
                            <td 
                                className="address"
                                xd-qa-type="label"
                                xd-qa-name={address.address+" "+address.zip_code+" Address"}
                            >
                                {address.address}
                                {!!address.do_not_mail ? (
                                    <span className="info-tip">
                                        {InformationBadge({
                                            height: 20,
                                            getTooltip: () => "Do Not Mail",
                                            direction: "east",
                                            xdQaName: address.address+" "+address.zip_code+" DNM",
                                        })}
                                    </span>
                                ) : !!address.excluded_target ? (
                                    <span className="info-tip">
                                        {InformationBadge({
                                            height: 20,
                                            getTooltip: () => "Target Address was previously excluded",
                                            direction: "east",
                                            xdQaName: address.address+" "+address.zip_code+" Excluded",
                                        })}
                                    </span>
                                ) : !address.pos.isMatched && (
                                    <span className="info-tip">
                                        {InformationBadge({
                                            height: 20,
                                            icon: "fa-exclamation",
                                            getTooltip: () => "Available, but not plotted on map",
                                            direction: "east",
                                            xdQaName: address.address+" "+address.zip_code+" Unplotted",
                                        })}
                                    </span>
                                )}
                            </td>
                            <td
                                className="zip"
                                xd-qa-type="label"
                                xd-qa-name={address.address+" "+address.zip_code+" Zip"}
                            >
                                {address.zip_code}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        )}
    </div>
);